function GroupActive() {
  return (
    <svg fill="#1b74e4" width="24" height="24" viewBox="0 0 24 24">
      <path d="M12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path>
      <path d="M12 23.5C5.649 23.5.5 18.351.5 12S5.649.5 12 .5 23.5 5.649 23.5 12 18.351 23.5 12 23.5zM3.373 8.017a4 4 0 0 1 0 7.966 9.523 9.523 0 0 0 1.948 2.773A5.002 5.002 0 0 1 10 15.523h4a5.002 5.002 0 0 1 4.679 3.233 9.523 9.523 0 0 0 1.948-2.773 4 4 0 0 1 0-7.966A9.501 9.501 0 0 0 12 2.5a9.501 9.501 0 0 0-8.627 5.517z"></path>
    </svg>
  );
}

export default GroupActive;
